import julianFoto from "../assets/quienesSomos/me02.jpg";

export const SEBASTIAN_VILLAMIL_PHOTO = "/portafolio/sebastian-villamil.jpg";

export const OPEN_OPTIONS_LOGO = "/portafolio/open-options-logo.png?v=2";

export const OPEN_OPTIONS_CLIENTS_BANNER = "/portafolio/clientes-referencia.png";

export const openOptionsTeamPhotos = {
  "manuel-cortes":
    "https://www.openoptions.co/wp-content/uploads/2013/09/FOTO-MANUEL-F-scaled.jpg",
  "luz-lozada":
    "https://www.openoptions.co/wp-content/uploads/2013/09/Luz-Marina-Lozada.jpg",
  "lineth-rodriguez":
    "https://www.openoptions.co/wp-content/uploads/2013/09/Imagen1.jpg",
  "jose-salas":
    "https://www.openoptions.co/wp-content/uploads/2013/09/0eaddf1d-6e3c-49fc-a93a-fcb0483ea6d2.jpg",
  "leidy-ramirez":
    "https://www.openoptions.co/wp-content/uploads/2020/08/FOTO-LEIDY-05.jpg",
};

const openOptionsMembers = [
  {
    id: "manuel-cortes",
    name: "Manuel F. Cortes N.",
    role: "Director",
    org: "Open Options",
    allied: true,
    focus:
      "Más de 30 años en gerencia integral en Coca-Cola FEMSA y Banco Ganadero (BBVA). Especialista en mercadeo, finanzas, administración y desarrollo humano.",
    photo: openOptionsTeamPhotos["manuel-cortes"],
    photoPosition: "50% 5%",
  },
  {
    id: "luz-lozada",
    name: "Luz Marina Lozada A.",
    role: "Partner",
    org: "Open Options",
    allied: true,
    focus:
      "Más de 30 años en sector bancario y Ministerio de Hacienda. Experta en procesos organizacionales, BPM y proyectos con PNUD y UGPP.",
    photo: openOptionsTeamPhotos["luz-lozada"],
    photoPosition: "50% 10%",
  },
  {
    id: "lineth-rodriguez",
    name: "Lineth Rodriguez Ruge",
    role: "Partner",
    org: "Open Options",
    allied: true,
    focus:
      "Coach ejecutiva y mercadeo. Experiencia directiva en Alpina, El Rey, Belcorp y Grasco. Facilitación de equipos comerciales de alto desempeño.",
    photo: openOptionsTeamPhotos["lineth-rodriguez"],
    photoPosition: "50% top",
  },
  {
    id: "jose-salas",
    name: "José Luis Salas H.",
    role: "Partner",
    org: "Open Options",
    allied: true,
    focus:
      "MBA (USC) y especialista en finanzas. Desarrollo estratégico, administrativo y comercial en consumo masivo y servicios.",
    photo: openOptionsTeamPhotos["jose-salas"],
    photoPosition: "50% top",
  },
  {
    id: "leidy-ramirez",
    name: "Leidy Ramírez",
    role: "Partner",
    org: "Open Options",
    allied: true,
    focus:
      "Comunicación, diseño e imagen corporativa. Branding, editorial e impresión para fortalecer la propuesta comercial de sus clientes.",
    photo: openOptionsTeamPhotos["leidy-ramirez"],
    photoPosition: "50% top",
  },
];

export const openOptionsTeam = openOptionsMembers;

export const alliedTeam = [
  {
    id: "julian-herrera",
    name: "Julian Herrera",
    role: "CEO & Co-founder",
    org: "MEU Aliado",
    allied: false,
    degree: "Economista · Universidad de los Andes · Maestría PEG en Economía (2025 – 2027)",
    focus:
      "Lidera la dirección de innovación financiera. Seis años como director financiero, relación con inversionistas y financiamiento alternativo. Python, Excel, Power BI y Bloomberg.",
    photo: julianFoto,
    photoPosition: "50% top",
  },
  {
    id: "sebastian-villamil",
    name: "Sebastian Villamil",
    role: "Finanzas corporativas y capital privado",
    org: "MEU Aliado",
    allied: false,
    degree: "Economista · Universidad de los Andes",
    focus:
      "Experto en capital privado y finanzas corporativas. Estructuración de inversiones, valoración de empresas y acompañamiento en transacciones de alto impacto.",
    photo: SEBASTIAN_VILLAMIL_PHOTO,
    photoPosition: "50% 20%",
  },
  ...openOptionsMembers,
];
